import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const CirclePlusIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
  margin,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    style={{ margin }}
  >
    <path
      d="M12 7v5m0 0v5m0-5H7m5 0h5m5 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.47715 10 10Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
